export default {
    id: "38746e9b-1091-41f9-bb3a-2e6dfae5d056",
    icon: "mdi-chart-line-variant",
    name: "shapeLineConnector",
    title: "Shape Line Connector",
    description: "A block line connector",
}